export default {
	title: "Tipos de Atendimento",
	medium: "Médium",
	guide: "Guia",
	numberingMode: "Modo de Exibição",
	maxTickets: "Máx. Fichas",
	tracksTime: "Controla Tempo",
	hasQueue: "Possui Fila",
	status: "Status",
	createdAt: "Criado em",
	updatedAt: "Atualizado em",
	details: {
		configuration: "Configuração",
		linkedRitualTypes: "Tipos de Rituais Vinculados",
		noLinkedRitualTypes: "Nenhum tipo de ritual vinculado",
	},
	edit: "Editar Tipo de Atendimento",
	create: "Criar Tipo de Atendimento",
	delete: "Excluir Tipo de Atendimento",
	activate: "Ativar",
	deactivate: "Desativar",
	viewDetails: "Ver Detalhes",
	deleteConfirmation: "Deseja realmente excluir o tipo de atendimento {label}?",
	form: {
		code: {
			label: "Código",
			placeholder: "Ex: A, B, PAS, PRES",
			hint: "Código curto da ficha (prefixo do fullCode)",
		},
		label: {
			label: "Nome da Ficha",
			placeholder: "Ex: Consulta Caboclo Pena Branca",
			hint: "Nome descritivo do tipo de atendimento",
		},
		medium: {
			label: "Médium Padrão",
			hint: "Médium que atenderá nesta ficha por padrão",
		},
		guide: {
			label: "Guia Espiritual (opcional)",
			placeholder: "Selecione um guia",
			hint: "Guia espiritual associado a este atendimento (não obrigatório)",
		},
		numberingMode: {
			label: "Modo de Exibição",
		},
		maxTickets: {
			label: "Máximo de Fichas",
			hint: "Quantidade máxima de fichas (obrigatório para modo Fixa)",
		},
		tracksTime: {
			label: "Controlar Tempo",
			hint: "Registrar tempo de início e fim do atendimento",
		},
		hasQueue: {
			label: "Possui Fila",
			hint: "Fichas são chamadas em ordem (desmarque para presença/registro simples)",
		},
	},
	numberingModes: {
		INCREMENTAL: "Sob demanda",
		PRE_DEFINED: "Fixa",
		incrementalDescription: "Fichas adicionadas uma a uma, conforme demanda",
		preDefinedDescription: "Mostra todas as fichas de 1 a N de uma vez",
	},
	messages: {
		created: "Tipo de atendimento {label} criado com sucesso",
		updated: "Tipo de atendimento {label} atualizado com sucesso",
		deleted: "Tipo de atendimento {label} excluído com sucesso",
		activated: "Tipo de atendimento {label} ativado com sucesso",
		deactivated: "Tipo de atendimento {label} desativado com sucesso",
		createError: "Erro ao criar tipo de atendimento",
		updateError: "Erro ao atualizar tipo de atendimento",
		deleteError: "Erro ao excluir tipo de atendimento",
		loadError: "Erro ao carregar tipos de atendimento",
		toggleError: "Erro ao alterar status do tipo de atendimento",
	},
	searchPlaceholder: "Código, nome ou guia...",
	loading: "Carregando detalhes...",
	filters: {
		status: {
			all: "Todos",
		},
	},
	table: {
		code: "Código",
		label: "Nome",
		medium: "Médium",
		guide: "Guia",
		numberingMode: "Modo de Exibição",
		linkedRitualTypes: "Vinculações",
		status: "Status",
	},
	empty: {
		title: "Nenhum tipo de atendimento encontrado",
		description: "Cadastre os tipos de ficha de atendimento para seus rituais",
	},
	stats: {
		total: "Tipos",
		active: "Ativos",
	},
	buttons: {
		create: "Novo Tipo de Atendimento",
		delete: "Excluir",
	},
	validation: {
		codeRequired: "Código é obrigatório",
		codeMaxLength: "Código deve ter no máximo 4 caracteres",
		labelRequired: "Nome é obrigatório",
		labelMaxLength: "Nome deve ter no máximo 100 caracteres",
		maxTicketsRequired: "Quantidade máxima é obrigatória para modo Fixa",
		maxTicketsMin: "Quantidade mínima é 1",
	},
};
